(function () {
  var labels = document.querySelectorAll('.m-search-form__label-typed[data-typewriter]');
  if (!labels.length) return;

  labels.forEach(function (label) {
    if (label.dataset.typewriterInit) return;
    label.dataset.typewriterInit = 'true';

    var words = (label.dataset.words || '')
      .split(',')
      .map(function (w) { return w.trim(); })
      .filter(Boolean);

    if (words.length < 2) return;

    var wordIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var typingSpeed = 90;
    var deletingSpeed = 45;
    var pauseAfterType = 1400;
    var pauseAfterDelete = 300;

    function tick() {
      var currentWord = words[wordIndex];

      if (!deleting) {
        charIndex++;
        label.textContent = currentWord.slice(0, charIndex);
        if (charIndex === currentWord.length) {
          deleting = true;
          setTimeout(tick, pauseAfterType);
          return;
        }
        setTimeout(tick, typingSpeed);
      } else {
        charIndex--;
        label.textContent = currentWord.slice(0, charIndex);
        if (charIndex === 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          setTimeout(tick, pauseAfterDelete);
          return;
        }
        setTimeout(tick, deletingSpeed);
      }
    }

    tick();
  });
})();